module.exports = __webpack_public_path__ + "img/logo-mercado-pago.f623e03b.png";